//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TabColumnView',
  data: function data() {
    return {
      filter: '',
      fields: [{
        key: 'datasource_name',
        label: 'Datasource',
        class: 'w-15'
      }, {
        key: 'name',
        label: 'Column',
        class: 'w-10'
      }, {
        key: 'business_definition',
        label: 'Business Definition'
      }, {
        key: 'field_name',
        label: 'Original Column',
        class: 'w-10'
      }, {
        key: 'datatype',
        label: 'Datatype',
        class: 'w-5'
      }, {
        key: 'datatype_visualization',
        label: 'Datatype Visualization',
        class: 'w-8 text-center'
      }, {
        key: 'calculate_field',
        label: 'Calculated Field?',
        class: 'w-3 text-center'
      }, {
        key: 'formula',
        label: 'Formula',
        class: 'w-20'
      }, {
        key: 'filter',
        label: 'Filter',
        class: 'w-3 text-center'
      }, {
        key: 'parameter',
        label: 'Parametro',
        class: 'w-3 text-center'
      }]
    };
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    }
  }
};